module.exports = __webpack_public_path__ + "img/logo.5bfb8864.png";